import getTransmissions from '../../api/shop/getTransmissions';
import SelectWithFetch from './SelectWithFetch';

const SelectCarTransmissions = (props) => {
  return <SelectWithFetch fetch={getTransmissions} label="Тип коробки передач" placeholder="Укажите тип" {...props} />;
};

export default SelectCarTransmissions;
